import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from '@mui/material'

import { useAppContext } from '@/hooks'

type ConfirmDialogProps = {
	confirmLabel: string
	danger?: boolean
	message: string
	onClose: () => void
	onConfirm: () => void
	open: boolean
	title: string
}

export const ConfirmDialog = ({
	confirmLabel,
	danger = false,
	message,
	onClose,
	onConfirm,
	open,
	title,
}: ConfirmDialogProps) => {
	const { t } = useAppContext()

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="xs"
			fullWidth
			slotProps={{ paper: { sx: { borderRadius: '14px' } } }}
		>
			<DialogTitle sx={{ color: '#1F4954', fontSize: 16, fontWeight: 700 }}>
				{title}
			</DialogTitle>
			<DialogContent>
				<Typography sx={{ color: '#3D3D3D', fontSize: 13, lineHeight: 1.5 }}>
					{message}
				</Typography>
			</DialogContent>
			<DialogActions sx={{ pb: 2, px: 3 }}>
				<Button onClick={onClose} sx={{ textTransform: 'none' }}>
					{t('CANCEL')}
				</Button>
				<Button
					color={danger ? 'error' : 'primary'}
					variant="contained"
					disableElevation
					onClick={onConfirm}
					data-testid="deployment-package-confirm"
					sx={{ textTransform: 'none' }}
				>
					{confirmLabel}
				</Button>
			</DialogActions>
		</Dialog>
	)
}
